import React, { Component } from "react";
import ReactDOM from "react-dom";

const modalWrapper = noOverlay => {
    if (noOverlay)
        return {
            position: "fixed",
            left: 0,
            top: 0,
            overflow: "auto",
            zIndex: 9999,
            opacity: 2,
            pointerEvents: "none"
        };
    return {
        position: "fixed",
        width: "100%",
        height: "100%",
        background: "rgba(0,0,0,0.5)",
        left: 0,
        top: 0,
        overflow: "auto",
        zIndex: 9999,
        opacity: 2
    };
};
const portalStack = [];

class Portal extends Component {
    componentDidMount = async () => {
        portalStack.push(this);
        document.addEventListener("keydown", this.handleKeyPress);
        await this.setState({
            isLoading: false
        });
    };

    handleKeyPress = e => {
        if (e.keyCode === 27) {
            if (portalStack?.[portalStack?.length - 1] !== this) return;
            let imageEditModal = document.getElementById("modalId-image");
            e.preventDefault();
            if (!imageEditModal) {
                this.props.onCancel();
            }
        }
    };
    handleModalContainerOuterClick = event => {
        let modal = document.getElementById("modalId");
        if (event.target === modal) {
            this.props.onCancel();
        }
    };

    componentWillUnmount() {
        const stackIndex = portalStack?.indexOf(this);
        if (stackIndex > -1) portalStack?.splice(stackIndex, 1);
        document.body.classList.remove("modal-open");
        document.querySelector(".modal-backdrop") && document.querySelector(".modal-backdrop").remove();
        document.body.style.overflow = null;
        document.removeEventListener("keydown", this.handleKeyPress);
    }

    render() {
        document.body.classList.add("modal-open");
        return ReactDOM.createPortal(
            <div
                style={{ ...modalWrapper(this.props.noOverlay), ...(this.props.zIndex ? { zIndex: this.props.zIndex } : {}) }}
                id="testId"
                // onClick={e => this.handleModalContainerOuterClick(e)}
            >
                <div className="outer-modal-zm">{this.props.body}</div>
            </div>,
            document.querySelector("#commonModal")
        );
    }
}

export default Portal;
